<script setup lang="ts">
import { Icon } from '#components'

const { company } = useCompany()
const components = {
  facebook: h(Icon, { name: 'fa6-brands:facebook' }),
  linkedin: h(Icon, { name: 'fa6-brands:linkedin' }),
  instagram: h(Icon, { name: 'fa6-brands:instagram' }),
  twitter: h(Icon, { name: 'simple-icons:x' }),
}
</script>

<template>
  <div v-if="company.our_team.team">
    <div class="flex max-w-screen-sm flex-wrap items-center justify-center gap-4">
      <div
        v-for="member of company.our_team.team"
        :key="member.name"
        class="flex w-[148px] flex-col items-center justify-center p-4 md:w-[202px]"
      >
        <div class="relative h-32 w-32 rounded-lg">
          <NuxtImg :src="member.image.url" :alt="member.name" class="rounded-lg" />
          <div class="bordershadow-image absolute inset-0 rounded-lg bg-[#2aaea359] mix-blend-overlay" />
        </div>

        <Paragraph as="h2" size="normal" weight="medium" align="center" class="mb-1 mt-4 !text-gray-950">
          {{ member.name }}
        </Paragraph>

        <Paragraph as="p" size="normal" weight="normal" align="center" class="!text-gray-400">
          {{ member.role }}
        </Paragraph>

        <Paragraph
          v-if="member.no_experience"
          as="p"
          size="small"
          weight="normal"
          align="center"
          class="mb-2 !text-gray-400"
          >{{ member.no_experience + ' ' + $t('team.years_experience') }}</Paragraph
        >

        <div class="flex items-center justify-center gap-1">
          <a v-for="social of member.socials" :key="social.type" :href="social.link" target="_blank">
            <component :is="components[social.type as keyof typeof components]" class="h-5 w-5 !text-gray-500" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
